<template>
  <Modal
    :title="modalTitle"
    :saving="saving"
    saving-text="Processing..."
    :submit-btn-text="submitButtonText"
    :submit-btn-class="modalContents.submit_btn_class"
    @submit="handleContinueClick"
    @hide-modal="$emit('hide-modal')"
  >
    <div class="form-group">
      <WarningMessage v-if="modalContents.message">
        <span>{{ modalContents.message }}</span>
      </WarningMessage>
      <TextArea
        v-if="!modalContents.hide_input"
        v-model="reason"
        class="full-width"
        name="Reason"
        :label="modalContents.textarea_label"
        :error-message="v$.reason.$errors[0]?.$message"
      />
    </div>
  </Modal>
</template>

<script>
import WarningMessage from "serviceshift-ui/components/General/WarningMessage.vue";
import { mapActions } from "vuex";
import { EventBus } from "@/lib/event_bus.js";

import Modal from "@/components/Modal.vue";
import TextArea from "@/components/TextArea.vue";
import useVuelidate from "@vuelidate/core";
import { requiredIf } from "@vuelidate/validators";

export default {
  components: {
    Modal,
    TextArea,
    WarningMessage
  },
  props: {
    modalContents: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["hide-modal", "on-submit"],
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      reason: "",
      saving: false
    };
  },
  computed: {
    modalTitle() {
      return this.modalContents.title ? this.modalContents.title : "";
    },
    submitButtonText() {
      return this.modalContents.submit_btn_text || "Continue";
    }
  },
  validations() {
    return {
      reason: {
        requiredIf: requiredIf(() => !this.modalContents.hide_input),
        $autoDirty: true
      }
    };
  },
  methods: {
    ...mapActions(["breakJobSignature"]),
    handleContinueClick() {
      if (this.modalContents.action_url) {
        this.v$.$validate().then((valid) => {
          if (valid) {
            this.saving = true;
            this.breakJobSignature({
              action_url: this.modalContents.action_url,
              reason: this.reason
            })
              .then(this.handleBreakingSignatureSuccess)
              .catch(() => {
                this.saving = false;
              });
          }
        });
      } else {
        this.$emit("on-submit");
      }
    },
    handleBreakingSignatureSuccess() {
      this.saving = false;
      this.$emit("hide-modal");
      EventBus.$emit(this.modalContents.event_name);
      window.notify.success(this.modalContents.success_message);
    }
  }
};
</script>

<style lang="scss" scoped></style>
